import {
    ApiQuery,
    SortDirections,
    FilterOperators,
    Filter,
    FilterMetadata,
    FilterTypes,
} from "~/modules/filters/types";
import { AssetColumns } from "~/modules/assets/types";
import { ASSET_CLASS_IDS, TOKENIZATION_TYPE_IDS } from "~/consts";

// // // //

const DEAL_ROOM_ASSET_TICKERS = ["ONyc", "mGLOBAL", "CUSHY", "pAlpha"];

// "Data Room Available" sorts the same as "Highest AUM" at the API level - it
// additionally shows the deal room assets section. Since the two can't be told
// apart from the ApiQuery's sort, the selected option is tracked in page state
export const DATA_ROOM_SORT_OPTION_VALUE = "data-room";

export const DEAL_ROOM_ASSETS_QUERY: ApiQuery = {
    filter: {
        operator: FilterOperators.And,
        filters: [
            {
                field: AssetColumns.ticker,
                operator: FilterOperators.Equals,
                value: DEAL_ROOM_ASSET_TICKERS,
            },
        ],
    },
    sort: {
        field: AssetColumns.bridgedTokenValueDollar,
        direction: SortDirections.desc,
    },
    pagination: {
        page: 1,
        perPage: DEAL_ROOM_ASSET_TICKERS.length,
    },
};

export const ASSET_SCREENER_BASE_FILTER: Filter = {
    operator: FilterOperators.And,
    filters: [
        {
            field: AssetColumns.assetClassID,
            operator: FilterOperators.NotEquals,
            value: ASSET_CLASS_IDS.Cryptocurrency,
        },
        {
            field: AssetColumns.assetClassID,
            operator: FilterOperators.NotEquals,
            value: ASSET_CLASS_IDS.Stablecoin,
        },
        {
            field: AssetColumns.tokenCount,
            operator: FilterOperators.GreaterThan,
            value: 0,
        },
        {
            field: AssetColumns.primaryMarketID,
            operator: FilterOperators.GreaterThan,
            value: 0,
        },
        {
            field: AssetColumns.tokenizationTypeIDs,
            operator: FilterOperators.Includes,
            value: TOKENIZATION_TYPE_IDS.OnChainDistributed,
        },
        {
            field: AssetColumns.tokenizationTypeIDs,
            operator: FilterOperators.NotIncludes,
            value: TOKENIZATION_TYPE_IDS.OnChainRepresented,
        },
    ],
};

// Initial query for the asset screener list - also used to fetch the first page
// in getStaticProps, so the two must stay in sync
export const ASSET_SCREENER_DEFAULT_QUERY: ApiQuery = {
    filter: ASSET_SCREENER_BASE_FILTER,
    sort: {
        field: AssetColumns.bridgedTokenValueDollar,
        direction: SortDirections.desc,
    },
    pagination: {
        page: 1,
        perPage: 50,
    },
};

// transferability_type_ids isn't in the API's filter metadata, so we define it
// here - `includes` is the only allowed operator, so FilterFormField applies it
// (the API rejects `in` for this column - `includes` matches assets with ANY of the ids)
export const NON_KYC_FILTER_METADATA: FilterMetadata = {
    field: AssetColumns.transferabilityTypeIDs,
    content: { label: "Non KYC Only" },
    type: FilterTypes.StringSingleSelect,
    allowedOperators: [FilterOperators.Includes],
    defaultOperator: FilterOperators.Includes,
    defaultValue: null,
    displayInline: false,
};
